import * as React from 'react';

import { IUnderground } from '../../../../../../types/offer';
import { Time } from '../../../../../../components/Field/common/LocationField';

export const TimeContainer = ({ underground }: { underground: IUnderground }): React.JSX.Element | null => {
  if (!underground.transportType || !underground.time) {
    return null;
  }

  return <Time type={underground.transportType} time={underground.time} />;
};
